import type Phaser from 'phaser';
import { CHARACTERS } from '../../game/content/characters';

/** Bake the silhouette once so moving stones need no extra per-frame draws. */
export function prepareCharacterOutlines(textures: Phaser.Textures.TextureManager): void {
  for (const character of CHARACTERS) {
    const source = textures.get(character.textureKey).getSourceImage() as HTMLImageElement;
    const canvas = document.createElement('canvas');
    canvas.width = source.width;
    canvas.height = source.height;
    const context = canvas.getContext('2d');
    if (!context) continue;

    const mask = document.createElement('canvas');
    mask.width = canvas.width;
    mask.height = canvas.height;
    const maskContext = mask.getContext('2d');
    if (!maskContext) continue;
    maskContext.drawImage(source, 0, 0);
    maskContext.globalCompositeOperation = 'source-in';

    // Scale thickness to world pixels, including the smallest stones.
    for (const [thickness, color] of [[1.9, '#172622'], [1.15, '#f4edcf']] as const) {
      maskContext.fillStyle = color;
      maskContext.fillRect(0, 0, mask.width, mask.height);
      const radius = thickness * canvas.width / character.baseSize;
      for (let index = 0; index < 24; index += 1) {
        const angle = index * Math.PI * 2 / 24;
        context.drawImage(mask, Math.cos(angle) * radius, Math.sin(angle) * radius);
      }
    }
    context.drawImage(source, 0, 0);
    // Keep the original dimensions and origin aligned with the collision shapes.
    textures.remove(character.textureKey);
    textures.addCanvas(character.textureKey, canvas);
  }
}
